import type { FC } from 'react';
import type { CustomIconProps } from '../types';

const Filter: FC<CustomIconProps> = ({ width, height, dataTestId }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-testid={dataTestId}
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fill="#414042"
            d="M9 8c.932 0 1.712.638 1.935 1.5H12v1h-1.065a1.999 1.999 0 0 1-3.87 0H0v-1h7.065A1.999 1.999 0 0 1 9 8ZM4 0c.932 0 1.712.638 1.935 1.5H12v1H5.935a1.999 1.999 0 0 1-3.87 0H0v-1h2.065A1.999 1.999 0 0 1 4 0Z"
        />
    </svg>
);

export default Filter;
